import pick from 'lodash/pick';

import {
  makeRequiredFieldsValidator,
  useFormState,
  useFormValidation,
  useInitialState,
} from '../../../../hocs/useFormWithValidation';

export function useSimpleForm(
  initialFields,
  validateFields,
  errors,
  initialData = {},
) {
  const initialState = useInitialState(initialFields);

  const { formState, handleFormChange } = useFormState({
    ...initialState,
    ...pick(initialData, initialFields),
  });

  const { validateErrors, clearErrors } = useFormValidation(errors);
  const isValid = makeRequiredFieldsValidator(validateFields)(formState);

  return {
    formState,
    handleFormChange,
    validateErrors,
    clearErrors,
    isValid,
  };
}



// WEBPACK FOOTER //
// ./src/components/common/SimpleFormPopup/utils/useSimpleForm.js